const state = {
  self: null,
  domainsPath: '',
  role: [],
  roleId: ''
}

const getters = {
  self: state => state.self,
  domainsPath: state => state.domainsPath,
  role: state => state.role,
  roleId: state => state.roleId
}

const actions = {
  setRole ({ commit }, role) {
    commit('SET_ROLE', role)
  }
}

const mutations = {
  SET_SELF (state, self) {
    state.self = self
    state.domainsPath = `domains/${self.domain.id}`
    state.roleId = self.role_id
  },
  SET_ROLE (state, role) {
    state.role = role
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
